import { GROUP_TYPE } from 'src/utils/config';
import { checkPhoneNumber } from 'src/api/checkout';
import { showDialog } from 'src/utils/error_config';
import { MToast } from 'src/components/MToast';

const checkoutErrorMessages = {
  BUYER_NAME_REQUIRED: 'checkout.requiredNameTip',
  BUYER_EMAIL_REQUIRED: 'checkout.requiredEmailTip',
  BUYER_PHONE_REQUIRED: 'checkout.inputPhoneNumber',
  BUYER_PHONE_INVALID: 'checkout.phoneNumberInvalid',
  BLU_PHONE_REQUIRED: 'checkout.bluPhoneRequired',
  BLU_PHONE_INVALID: 'checkout.phoneNumberInvalid',
  SPUNBOND_QUOTE_CHANGED: 'checkout.packagingQuoteChanged',
  SPUNBOND_UNAVAILABLE: 'checkout.packagingQuoteChanged',
  SPUNBOND_STOCK_INSUFFICIENT: 'checkout.packagingQuoteChanged',
  ADDON_QUOTE_CHANGED: 'checkout.packagingQuoteChanged',
  ADDON_PRICE_CHANGED: 'checkout.packagingQuoteChanged',
  ADDON_UNAVAILABLE: 'checkout.addonSelectionChanged',
  ADDON_STOCK_INSUFFICIENT: 'checkout.addonSelectionChanged',
  ADDON_MAPPING_CHANGED: 'checkout.addonSelectionChanged',
  ADDON_PARENT_TYPE_UNSUPPORTED: 'checkout.addonSelectionChanged',
  INVALID_ADDON_PARENT: 'checkout.addonSelectionChanged',
  DUPLICATE_ADDON: 'checkout.addonSelectionChanged',
  SPUNBOND_QUOTE_FAILED: 'checkout.packagingQuoteFailed',
  INVALID_SPUNBOND_ENABLED: 'checkout.packagingQuoteFailed',
  ADDON_QUOTE_FAILED: 'checkout.packagingQuoteFailed',
};

function getCheckoutError(response) {
  const key = response?.data?.errorKey;
  const message = checkoutErrorMessages[key];
  if (!message) return null;
  return {
    key,
    message,
    buyerInfo: ['BUYER_NAME_REQUIRED', 'BUYER_EMAIL_REQUIRED', 'BUYER_PHONE_REQUIRED', 'BUYER_PHONE_INVALID'].includes(key),
    // AI-assisted 2026-09: Refresh changed prices once without resubmitting the order.
    refresh: ['SPUNBOND_QUOTE_CHANGED', 'ADDON_QUOTE_CHANGED', 'ADDON_PRICE_CHANGED'].includes(key),
  };
}

// AI-assisted 2026-09 START: Convert known checkout error keys into localized Toast messages.
export function handleCheckoutError(response, app) {
  const error = getCheckoutError(response);
  if (!error) return null;
  MToast({ msg: app.$t(error.message) });
  return error;
}
// AI-assisted 2026-09 END

// AI-assisted 2026-09 START: Explain server validation and return to the existing contact fields.
export function handleBuyerInfoFailure(response, app, user) {
  const error = getCheckoutError(response);
  if (!error?.buyerInfo) return false;
  MToast({ msg: app.$t(error.message) });
  user?.focusBuyerInfo?.(error.key);
  return true;
}
// AI-assisted 2026-09 END

// AI-assisted 2026-09 START: Normalize Blu account numbers independently of contact phones.
export function normalizeBluPhone(value) {
  const phone = String(value || '').trim();
  if (/^\+?628\d*$/.test(phone)) return `0${phone.replace(/^\+?62/, '')}`;
  if (/^8\d*$/.test(phone)) return `0${phone}`;
  return phone;
}

export function isBluPhoneValid(value) {
  return /^08\d{8,11}$/.test(normalizeBluPhone(value));
}

// AI-assisted 2026-09 END

export function isOVO(id) {
  return ['XE_OVO', 'OVO'].includes(id);
}
export function calcPromo(str) {
  return str.split('==');
}
export function isPkg(type) {
  return type === GROUP_TYPE.PACKAGE;
}

export function checkPhone(val, vm) {
  return new Promise((resolve, reject) => {
    checkPhoneNumber({ phone: val })
      .then((res = {}) => {
        const { code, data } = res;
        if (code === 200) return resolve(true);
        if (code === 507) {
          showDialog(vm, 507);
          resolve(false);
        }
      })
      .catch((_) => resolve(false));
  });
}

export function checkEmailOptional(email, vm) {
  return new Promise((resolve, reject) => {
    const optional = vm.emailOptional;
    if (!optional && !email) {
      showDialog(vm, 8002);
      reject();
    } else { resolve() }
  })
}
